import { resolvePath } from 'src/cdn';
import noImagePath from 'src/common-ui/images/noimage.jpg';
import { AppType } from 'configuration-schemas/general';

export const noImage = resolvePath(noImagePath);

export const API_URL_PREFIX = '/asst' as const;

export const TOP_DOWN_IDENTIFIER = 'TD_' as const;
export const FLOWSTATUSPROP = 's5flowstatus' as const;
export const FUNDEDSTATUSPROP = 's5fundedstatus' as const;
export const ASSORTMENT = AppType.Assortment;
export const TOP_DOWN = AppType.TDAnalysis;
export const CONFIGURATOR = AppType.Configurator;
export const SLSR_BAND = 'slsr_band' as const;
export const PERFORMANCE = 'ccperf' as const;

// Tab ID's
export const HINDSIGHTING = 'Hindsighting' as const;
export const ASSORTMENT_STRATEGY = 'AssortmentStrategy' as const;
export const ASSORTMENT_BUILD = 'AssortmentBuild' as const;
export const ASSORTMENT_ANALYSIS = 'AssortmentAnalysis' as const;
export const RECONCILIATION = 'AnalysisAndRecon' as const;
export const REPORTING = 'Reporting' as const;
export const ALLOCATION = 'Allocation' as const;

// Tab Paths's
export const HINDSIGHTING_CONTEXT = 'hindsighting' as const;
export const ASSORTMENT_CONTEXT = 'assortment' as const;
export const ASSORTMENT_STRATEGY_PATH = 'assortment-strategy' as const;
export const ASSORTMENT_BUILD_PATH = 'assortment-build' as const;
export const ASSORTMENT_ANALYSIS_PATH = 'assortment-analysis' as const;
export const RECONCILIATION_PATH = 'reconciliation' as const;
export const REPORTING_PATH = 'reporting' as const;
export const ALLOCATION_PATH = 'allocation' as const;

// Attribute
export const CC_COLOR = 'attribute:cccolor:id' as const;
export const CC_COLOR_ID = 'attribute:cccolorid:id' as const;
export const IMG_URI = 'attribute:img:id' as const;
export const DEPARTMENT_ID = 'member:department:id' as const;
export const STYLE_ID = 'member:style:id' as const;
export const STYLE_NAME = 'member:style:name' as const;
export const STYLE_DESCRIPTION = 'member:style:description' as const;
export const STYLE_COLOR_DESCRIPTION = 'member:stylecolor:description' as const;
export const STYLE_COLOR_ID = 'member:stylecolor:id' as const;
export const STYLE_COLOR_NAME = 'member:stylecolor:name' as const;
export const CLASS_ID = 'member:class:id' as const;
export const CLASS_NAME = 'member:class:name' as const;
export const SUBCLASS_ID = 'member:subclass:id' as const;
export const SUBCLASS_NAME = 'member:subclass:name' as const;
export const EXP_POWERDRIVER_ID = 'level:subclass:id' as const; // express powerdriver attribute, special mapping
export const STYLE_COLOR_IS_REMOVABLE = 'attribute:isremovable:id' as const;
export const TIME = 'time' as const;
export const FUNDED = 'isfunded' as const;
export const SPECIAL_STORE_GROUP = 'ssg' as const;
export const STORE_COUNT = 'store_count' as const;
export const COLOR_HEADER = 'color_header' as const;
export const ADJUSTED_APS = 'adjaps' as const;
export const SLSR = 'slsr' as const;
export const AGG_DEPARTMENT = 'levels:department' as const;
export const SWATCHES = 'swatchids' as const;
export const ATTRIBUTE = 'attribute' as const;
export const ID = 'id' as const;
export const NAME = 'name' as const;
export const DESCRIPTION = 'description' as const;
export const lookBackPeriodProp = 'ytd_key' as const;
export const XTYPE_UNIQUE = 'unique' as const;
export const RANGE_CODE = 'ccrangecode' as const;
export const VALID_SIZES = 'attribute:validsizes:id' as const;
export const IS_PUBLISHED = 'dc_publish' as const;
export const USERADJ = 'dc_useradj' as const;
export const ONORDERREVISION = 'dc_finrev' as const;
export const SLSUOVERRIDE = 'weekadjslsu' as const;
export const FINAL_QTY = 'dc_finalqty' as const;
export const LAST_PUBLISHED = 'dc_last_pub' as const;
export const FINALSLSU = 'slsu' as const;
export const ATTR_GRADE = 'attribute:grade:id' as const;
export const ATTR_CLIMATE = 'attribute:strclimate:id' as const;
export const ATTR_MENSCAPACITY = 'attribute:strmenscapacity:id' as const;
export const ATTR_WOMENSCAPACITY = 'attribute:strwomenscapacity:id' as const;
export const ATTR_FUNDED = 'attribute:isfunded:id' as const;
export const ATTR_SSG = 'attribute:ssg:id' as const;
export const IS_LOCKED = 'is_locked' as const;

export const PUBLISHED_TEXT = 'PUBLISHED' as const;
export const UNPUBLISHED_TEXT = 'PLANNED' as const;
export const PARTIAL_PUBLISHED_TEXT = 'PARTIAL' as const;
export const NO_RECEIPTS_TEXT = 'NO RECEIPTS PLANNED' as const;

// Grid defaults
export const externalGridSearchFields = [
  'name',
  'description',
  STYLE_NAME,
  STYLE_COLOR_NAME,
  STYLE_DESCRIPTION,
  STYLE_COLOR_DESCRIPTION,
] as const;

const ADD_EXISTING_STYLE_KEY = 'add-existing' as const;
const ADD_EXISTING_STYLECOLOR_KEY = 'add-existing-stylecolors' as const;
const ADD_SIMILAR_STYLE_KEY = 'add-similar' as const;
const ADD_SIMILAR_STYLECOLOR_KEY = 'add-similar-stylecolors' as const;
const SELECT_STYLES_PATH = '/bottom-up/assortment-build/select-styles' as const;

export const ADD_EXISTING_PATH = `${SELECT_STYLES_PATH}/${ADD_EXISTING_STYLE_KEY}` as const;
export const ADD_EXISTING_STYLECOLOR_PATH = `${SELECT_STYLES_PATH}/${ADD_EXISTING_STYLECOLOR_KEY}` as const;
export const ADD_SIMILAR_STYLECOLOR_PATH = `${SELECT_STYLES_PATH}/${ADD_SIMILAR_STYLECOLOR_KEY}` as const;
export const ADD_SIMILAR_PATH = `${SELECT_STYLES_PATH}/${ADD_SIMILAR_STYLE_KEY}` as const;

// Dimension
export const DIMENSION_PRODUCT_LIFE = 'prodlife' as const;
export const DIMENSION_PRODUCT = 'product' as const;
export const DIMENSION_CLUSTER = 'cluster' as const;

// Important Levels
// Bottom Levels
export const LEVEL_MERCHCAT = 'level:merchcat' as const;
export const LEVEL_GRADE = 'level:grade' as const;
export const LEVEL_WEEK = 'level:week' as const;
export const LEVEL_STORE = 'level:store' as const;
export const LEVEL_STYLE = 'level:style' as const;
export const LEVEL_STYLE_COLOR = 'level:stylecolor' as const;

// TOP LEVELS
export const LEVEL_PROD_ROOT = 'level:prodrootlevel' as const;

export const LEVEL_MONTH = 'level:month' as const;

export const STYLE_REVIEW = 'styleReview' as const;
export const STYLE_COLOR_REVIEW = 'styleColorReview' as const;

export const ISASSORTMENT = 'attribute:isassortment:id' as const;
export const CCCOLORID = 'attribute:cccolor:id' as const;

// TODO: Move this to a config
export const reorderGroups = [
  {
    id: PERFORMANCE,
    order: ['1', '2', '3', '4', '5'],
    nameMap: {
      '1': 'Top 20%',
      '2': 'Above Average',
      '3': 'Average',
      '4': 'Below Average',
      '5': 'Bottom 20%',
    },
  },
  {
    // period characters interfere with some of the grouping
    // but they get remapped into the name here
    // the special sorting for shopzilla is also done here
    id: 'attribute:sty_shopzilla_rating:name',
    order: ['ShopZilla 4\u20245 to 5', 'ShopZilla 4 to 4\u20245', 'ShopZilla 3\u20245 to 4', 'ShopZilla 0 to 1'],
    nameMap: {
      'ShopZilla 4\u20245 to 5': 'ShopZilla 4.5 to 5',
      'ShopZilla 4 to 4\u20245': 'ShopZilla 4 to 4.5',
      'ShopZilla 3\u20245 to 4': 'ShopZilla 3.5 to 4',
      'ShopZilla 0 to 1': 'ShopZilla 0 to 1',
    },
  },
  {
    // period characters interfere with some of the grouping
    // but they get remapped into the name here
    // the special sorting for shopzilla is also done here
    id: 'attribute:slsrnk:name',
    order: [1, '15', 2, '25', 3, '35', 4, '45', 5],
    nameMap: {
      [1]: '1',
      ['15']: '1.5',
      [2]: '2',
      ['25']: '2.5',
      [3]: '3',
      ['35']: '3.5',
      [4]: '4',
      ['45']: '4.5',
      [5]: '5',
    },
  },
] as const;

export const FLOW_VALUES = ['NEW', 'FLOW', 'LOF'] as const;
export const TYLY_VALUES = ['TY', 'LY'] as const;
export const FLOORSET_VALUES = ['SELECTED', 'PREVIOUS', 'LAST YEAR'] as const;

export const keys = {
  enter: 13,
  space: 32,
} as const;

export const isReserved = (dataIndex: string) => {
  return (
    dataIndex.toLocaleLowerCase() === 'member:style:id' || dataIndex.toLocaleLowerCase() === 'member:stylecolor:id'
  );
};

// Companion View

export const COMPANION_EXPANDED_WIDTH = 300 as const;
export const COMPANION_COLLAPSED_WIDTH = 100 as const;

export const STYLE_SUBMITTED_ATTR = 'attribute:ccstylecreatedate:name' as const;
export const LOCKED_AFTER_STYLE_SUBMIT = [
  'name',
  'description',
  'member:style:name',
  'member:style:description',
  'attribute:ccsizerange:name',
  'attribute:ccsizerange:id',
] as const;

export const COLOR_SUBMITTED_ATTR = 'attribute:ccstylecolorcreatedate:name' as const;
export const LOCKED_AFTER_COLOR_SUBMIT = [
  'attribute:cccolor:id',
  'attribute:cccolor:name',
  'attribute:cccolorid:id',
  'attribute:cccolorid:name',
] as const;

// Ag Grid Editors
export const ALLOW_ENTER_EDITORS = ['text'] as const;
export const BLOCK_ENTER_EDITORS = [
  'lifecycleParameters',
  'salesAdjustment',
  'popoverSelect',
  'receiptsAdjCalculator',
  'tabbedReceiptsAdjCalculator',
  'validValues',
  'textValidator',
  'multiRangeEditors',
] as const;
export const EDITORS_TO_IGNORE_CHANGE_DETECTION = [
  'lifecycleParameters',
  'salesAdjustment',
  'receiptsAdjCalculator',
  'configurableDataModal',
] as const;
export const POPOVER_BLOCK_CODES = ['Enter', 'Tab', 'NumpadEnter'] as const;
export const ARRAY_EDITOR_COLUMN_ID_PREFIX = 'array_editor' as const;

export const CROPPED_IMG_MAX_WIDTH = 300 as const;
export const CROPPED_IMG_MAX_HEIGHT = 450 as const;

export const CANCELMESSAGE = 'Data updated: Fetching new pivot results...' as const;
export const ASSORTMENT_BUILD_FILTER_WARNING = 'Location filters do not apply on this view' as const;
export const ASSORTMENT_BUILD_FILTER_ALL_WARNING = 'All filters do not apply on this view' as const;
export const CACHED_DATA_EDITING_DISABLED_WARNING =
  'Editing is disabled while live data is loading. Cached data shown.' as const;

export const UNINITIALIZED = '_empty_' as const;

export const FAVORITE_EXCLUDE_KEYS = [
  'actions',
  'main',
  'massEditConfig',
  'salesAdjustment',
  'subheaderDropdowns',
  'searchIndexes',
] as const;

// mfp stuff dumped here
// dimension constants
export const PRODUCT = 'product' as const;
export const LOCATION = 'location' as const;
export const METRICS = 'metrics' as const;
export const REVISIONS = 'revisions' as const;
export const PRODLIFE = 'prodlife' as const;

// version types
export const VARIANCE_VERSION = 'VarianceVersion' as const;
export const SINGLE_VERSION = 'SingleVersion' as const;
export const PERCENT_TO_TOTAL_VERSION = 'PercentToTotal' as const;
export const PERCENT_TO_GRAND_TOTAL_VERSION = 'PercentToGrandTotal' as const;
export type VERSION_TYPES =
  | typeof VARIANCE_VERSION
  | typeof SINGLE_VERSION
  | typeof PERCENT_TO_TOTAL_VERSION
  | typeof PERCENT_TO_GRAND_TOTAL_VERSION;
export const VERSION_TYPE_LIST = [
  VARIANCE_VERSION,
  SINGLE_VERSION,
  PERCENT_TO_TOTAL_VERSION,
  PERCENT_TO_GRAND_TOTAL_VERSION,
] as const;

// scope type constants
export const SCOPETYPE_ACTUALS = 'actuals' as const;
export const SCOPETYPE_PLAN = 'plan' as const;
export const SCOPETYPE_SUBMITTED = 'submitted' as const;
export const SCOPETYPE_APPROVED = 'approved' as const;
export const SCOPETYPE_WORKING = 'working' as const;

export const DEFAULT_DIMENSIONS = [PRODUCT, LOCATION, TIME] as const;

// revision constants
// TODO: move this to config or generate it
export const WP = 'wp' as const;
export const OP = 'op' as const;
export const RP = 'rp' as const;
export const LP = 'lp' as const;

// perspective constants
export const BOTTOM_UP = 'bottom_up' as const;
export const MIDDLE_OUT = 'middle_out' as const;
export const TOP_DOWN_MFP = 'top_down' as const;
export const GLOBAL_DOWN = 'global_down' as const;
// export const PERSPECTIVE_PATHS = [BOTTOM_UP, MIDDLE_OUT, TOP_DOWN, GLOBAL_DOWN] as const;

// export type PerspectivePaths = typeof BOTTOM_UP | typeof MIDDLE_OUT | typeof TOP_DOWN | typeof GLOBAL_DOWN;

// configurator constants
export const AVAILABLE = 'available' as const;

// rows cols
export const ROWS = 'rows' as const;
export const COLUMNS = 'columns' as const;

// renderer
export const DEFAULT_PERCENT_FORMAT = '0.00%' as const;

export const ROW_SELECTION_REQUIRED_TEXT = 'Select grid items for mass column edit' as const;
export const ROW_SELECTIONS_UPDATING_TEXT = 'Some selections are still updating' as const;
export const MISMATCHED_OPTIONS_TEXT = 'Selected rows options do not match, unable to mass column edit' as const;
